import React from 'react';
import './Animation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const ErrorPage = ({ message }) => {
  const refreshPage = () => window.location.reload();

  return (
    <div className="global-loader-overlay">
      <div className="error-wrapper">
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="error-animation"
        />
        <h2>Wystąpił błąd</h2>
        <p>{message || 'Spróbuj ponownie później.'}</p>
        <button className="refresh-btn" onClick={refreshPage}>
          Odśwież stronę
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
